var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    _vm._l(_vm.releaseNotesCards, function (release) {
      return _c(
        "v-card",
        { key: release.name, staticClass: "my-2", attrs: { outlined: "" } },
        [
          _c(
            "v-card",
            { staticClass: "d-flex pb-1", attrs: { flat: "" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "", width: "160" } },
                [
                  _c("v-card-title", [_vm._v(_vm._s(release.name))]),
                  _c("v-card-subtitle", [
                    _vm._v(_vm._s(_vm.timeFrom(release.date)) + " ago"),
                  ]),
                ],
                1
              ),
              _c("v-divider", {
                staticClass: "mx-4",
                attrs: { vertical: "", inset: "" },
              }),
              _c("v-card-text", { staticClass: "pa-0 mb-2" }, [
                _c("div", {
                  staticClass: "markdown",
                  domProps: { innerHTML: _vm._s(release.html) },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }